import useLogoutMutation from '@input-web/modules/user/hooks/mutations/use-logout-mutation.hook';
import { useEffect } from 'react';
import useUserInfoQuery from '../../../user/hooks/queries/use-user-info-query.hook';
import useInitializeAuthMutation from './hooks/mutations/use-initialize-auth-mutation.hook';
import useAuthHandler from './hooks/ui-handlers/use-auth-handler.hook';
import useErrorDialogHandler from './hooks/ui-handlers/use-error-dialog-handler.hook';
import useLoadingHandler from './hooks/ui-handlers/use-loading-handler.hook';

export default function useMainViewModel() {
  // #region Dependencies
  const logout = useLogoutMutation();
  useUserInfoQuery();
  // #endregion

  // #region Mutations
  const initializeAuth = useInitializeAuthMutation();
  const { mutate: initialize } = initializeAuth;
  useEffect(() => {
    initialize();
  }, [initialize]);
  // #endregion

  // #region Handlers
  useAuthHandler(logout.handleUnauthorizedLogout);
  const loading = useLoadingHandler();
  const errorDialog = useErrorDialogHandler();
  // #endregion

  return { errorDialog, initializeAuth, loading };
}
